{
  "verse": {
    "loading": "Inapakia aya...",
    "error": "Imeshindwa kupakia aya",
    "reference": "— Sura {{surah}}, Aya {{ayah}}",
    "arabicUnavailable": "(Kiarabu hakipatikani)",
    "english": "Kiingereza",
    "arabic": "العربية",
    "swapLanguage_aria": "Badilisha lugha",
    "toggleLanguage_title": "Geuza Kiingereza / Kiarabu",
    "reflect": "Tafakari",
    "reflecting": "Inafikiri…",
    "reflect_aria": "Tengeneza tafakuri binafsi inayounganisha aya hii na nia yako",
    "insights": "Mwanga",
    "insights_aria": "Fungua Mwanga wa Quran wa AI",
    "share": "Shiriki",
    "share_aria": "Shiriki aya hii kama picha",
    "share_title": "Shiriki aya hii",
    "removeFromFavorites_aria": "Ondoa kutoka kwenye vipendwa",
    "saveToFavorites_aria": "Hifadhi kwenye vipendwa",
    "favoritesProLocked_aria": "Vipendwa ni kipengele cha Pro",
    "favoritesUpgrade_aria": "Pandisha ili kuhifadhi vipendwa",
    "signInToSave": "Ingia ili kuhifadhi vipendwa.",
    "failedToUpdateFavorites": "Imeshindwa kusasisha vipendwa",
    "couldNotReflect": "Imeshindwa kutengeneza tafakuri",
    "shareCaption": "\"{{text}}\"\n— Sura {{surah}}, Aya {{ayah}}\n\nrhemn.com",
    "imageSavedVerseCopied": "Picha imehifadhiwa · aya imenakiliwa",
    "imageSaved": "Picha ya aya imehifadhiwa",
    "couldNotCreateImage": "Imeshindwa kuunda picha"
  },
  "insights": {
    "panel_aria": "Paneli ya Mwanga wa Quran",
    "title": "Mwanga",
    "reference": "Sura {{surah}}, Aya {{ayah}}",
    "close_aria": "Funga paneli ya Mwanga",
    "versePreview_aria": "Onyesho la awali la aya",
    "back_aria": "Rudi",
    "tryAgain": "Jaribu tena",
    "backTo_aria": "Rudi kwa {{ref}}",
    "copyVerse_aria": "Nakili {{ref}}",
    "openingVerse": "Inafungua aya…",
    "verseError": "Imeshindwa kufungua aya."
  },
  "proGate": {
    "title": "Mwanga wa Quran wa AI ni kipengele cha Pro",
    "subtitleSafari": "Unlock deep, contextual understanding of every verse with Rhemn Pro. Already a member? It unlocks automatically when you sign in.",
    "subtitle": "Fungua uelewa wa kina na wa muktadha wa kila aya.",
    "bulletAsk": "Uliza swali lolote kuhusu aya",
    "bulletTafsir": "Muhtasari wa tafsiri wa papo hapo unaoendeshwa na AI",
    "bulletRelated": "Gundua aya zinazohusiana kimaudhui",
    "upgrade": "Pandisha hadi Pro"
  },
  "ask": {
    "heading": "Uliza",
    "suggestion1": "Ni upi muktadha mpana wa aya hii?",
    "suggestion2": "Ninawezaje kuitumia hii katika maisha ya kila siku?",
    "suggestion3": "Wanazuoni wa kale wanasemaje kuhusu hili?",
    "placeholder": "Uliza chochote kuhusu aya hii…",
    "input_aria": "Uliza swali kuhusu aya hii",
    "submit_aria": "Wasilisha swali",
    "submit_title": "Wasilisha (⌘↵)",
    "submit_label": "Uliza",
    "submit_hint": "⌘↵",
    "suggestions_aria": "Maswali yaliyopendekezwa",
    "error": "Imeshindwa kupata jibu.",
    "pending": "Tunatafakari swali lako…",
    "attribution": "Jibu lililotengenezwa na AI · Si mbadala wa elimu ya wanazuoni waliohitimu"
  },
  "tafsir": {
    "heading": "Tafsiri",
    "emptyText": "Pata muhtasari wa tafsiri uliotengenezwa na AI kwa aya hii.",
    "generate": "Tengeneza Tafsiri",
    "commentary": "Maelezo",
    "regenerate": "Tengeneza upya",
    "regenerate_aria": "Tengeneza tafsiri upya",
    "attribution": "Muhtasari uliotengenezwa na AI · Si mbadala wa elimu ya wanazuoni waliohitimu",
    "error": "Imeshindwa kutengeneza tafsiri.",
    "pending": "Tunasoma maelezo…"
  },
  "related": {
    "heading": "Aya Zinazohusiana",
    "copied": "Imenakiliwa: {{ref}}",
    "failedToCopy": "Imeshindwa kunakili",
    "empty": "Hakuna aya zinazohusiana zilizopatikana.",
    "error": "Imeshindwa kupakia aya zinazohusiana.",
    "pending": "Tunatafuta aya zinazohusiana…"
  },
  "favorites": {
    "panel_aria": "Aya pendwa",
    "title": "Aya Pendwa",
    "proLocked": "Aya pendwa ni kipengele cha Pro.",
    "loading": "Inapakia…",
    "failedToLoad": "Imeshindwa kupakia vipendwa",
    "empty": "Bado hakuna vipendwa. Gusa moyo kwenye aya yoyote ili kuihifadhi.",
    "reference": "— Sura {{surah}}, Aya {{ayah}}",
    "remove_aria": "Ondoa kutoka kwenye vipendwa",
    "failedToRemove": "Imeshindwa kuondoa"
  }
}
